export default __webpack_public_path__ + "static/media/collab-image.7fb6765b.png";